import { Autocomplete, Stack, TextField, Typography } from '@mui/material';

import {
  addWhereClause,
  deleteWhereClause,
} from '@modules/_shared/components/filters/Filters';
import { useSchema } from '@modules/_shared/components/filters/useSchema';

import {
  DeleteButton,
  autocompleteClearIcon,
  autocompletePopupIcon,
  autocompleteSx,
} from './DeleteButton';

interface EnumProps {
  name: string;
  node: any;
  path: string[];
  where: any;
  setWhere: (where: any) => void;
}

export const Enum = ({ name, node, path, where, setWhere }: EnumProps) => {
  const { getTypeFromPath, getTypeByName } = useSchema();
  const type = getTypeFromPath(path);

  if (!type) {
    throw new Error('No type found for ' + path.join('.'));
  }

  const fullType = getTypeByName(type.name);

  if (fullType?.kind !== 'ENUM') {
    throw new Error('Type is not an enum');
  }

  const enumValues = fullType.enumValues.map(ev => ev.name);

  return (
    <Stack
      direction="row"
      sx={{
        gap: 0.5,
        alignItems: 'center',
      }}
    >
      <Typography
        variant="body2"
        sx={{
          color: 'text.secondary',
          whiteSpace: 'nowrap',
        }}
      >
        {name}
      </Typography>
      <Autocomplete
        value={node}
        multiple={Array.isArray(node)}
        options={enumValues ?? []}
        disableCloseOnSelect
        popupIcon={autocompletePopupIcon}
        clearIcon={autocompleteClearIcon}
        renderInput={params => (
          <TextField
            {...params}
            variant="outlined"
            placeholder={
              node?.length === 0 ? `+ Add filter (${name})` : undefined
            }
            size="small"
          />
        )}
        size="small"
        sx={{ minWidth: 280, ...autocompleteSx }}
        onChange={(e, value) => {
          let newWhere = deleteWhereClause(where, path);
          if (value) {
            newWhere = addWhereClause(newWhere, path, value);
          }
          setWhere(newWhere);
        }}
      />
      <DeleteButton
        onClick={() => {
          const newWhere = deleteWhereClause(where, path);
          setWhere(newWhere);
        }}
      />
    </Stack>
  );
};
